module.exports = __webpack_public_path__ + "img/视频专栏选中.54a75c60.png";